import React, {useState} from "react";
import {PlannerTask} from "../../../../../models/planner/planner";
import {Button, Space} from "antd";
import {TaskDepartment} from "./task.department";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PlannerTasksDepartmentAddModal} from "./task.department.add.modal";

interface TaskDepartmentsProps {
    task: PlannerTask;
    reload: () => void;
}

export const TaskDepartments: React.FC<TaskDepartmentsProps> = ({task, reload}) => {

    const [addModalShown, setAddModalShown] = useState<boolean>(false);

    const onComplete = () => {
        setAddModalShown(false);
        reload();
    }

    return (
        <Space direction={"vertical"}>
            {task.departments.map(department =>
                <TaskDepartment task={task} department={department} reload={reload} />)
            }
            <Button
                icon={<FontAwesomeIcon icon={["fas", "plus-circle"]}/>}
                type={"text"}
                size={"small"}
                onClick={() => setAddModalShown(true)}
            />
            {addModalShown ? (
                <PlannerTasksDepartmentAddModal
                    onClose={onComplete}
                    task={task}
                />
            ) : null}
        </Space>
    )
}
